import { NextPage } from "next";
import { useTranslation } from "next-i18next";
import Benefits from "../components/Career/Benefits";
import CareerHeader from "../components/Career/CareerHeader";
import Layout from "../components/Layout";
import Wanted from "../components/Career/Wanted/Wanted";
import Contact from "../components/Contact/Contact/Contact";

const CareerPage: NextPage = () => {
  const { t } = useTranslation("navigation");

  return (
    <Layout title={t("career")}>
      <CareerHeader />
      <Wanted />
      <Benefits />
      <Contact id="careerContactForm" variant="hr" showTitlePhrase />
    </Layout>
  );
};

export default CareerPage;
